import { Link } from "react-router-dom";
import { CaretRight } from "@phosphor-icons/react";
import { C } from "@/brand/tokens";

/**
 * Breadcrumb — interior page path indicator.
 *
 * Usage:
 *   <Breadcrumb trail={[
 *     { label: "Pathways", href: "/concept-e#pathways" },
 *     { label: "Leadership & People Advisory" }, // current, no href
 *   ]} tone="light" />
 */
export function Breadcrumb({ trail = [], tone = "light" }) {
  const isDark = tone === "dark";
  const textColor = isDark ? C.whiteOnDarkSoft : C.inkOnLightSoft;
  const currentColor = isDark ? C.textOnDark : C.textOnLight;
  const separator = isDark ? C.brassLine : C.accentMetal;

  return (
    <nav
      aria-label="Breadcrumb"
      className="font-inter text-[10.5px] uppercase font-semibold tabular-nums flex flex-wrap items-center gap-x-3 gap-y-1"
      style={{ letterSpacing: "0.24em" }}
    >
      {trail.map((crumb, i) => {
        const isLast = i === trail.length - 1;
        return (
          <span key={crumb.label} className="inline-flex items-center gap-3">
            {crumb.href ? (
              <Link
                to={crumb.href}
                className="transition-colors"
                style={{ color: textColor }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.color = C.accentMetal)
                }
                onMouseLeave={(e) => (e.currentTarget.style.color = textColor)}
              >
                {crumb.label}
              </Link>
            ) : (
              <span style={{ color: currentColor }}>{crumb.label}</span>
            )}
            {!isLast && (
              <CaretRight
                size={10}
                weight="bold"
                style={{ color: separator }}
              />
            )}
          </span>
        );
      })}
    </nav>
  );
}
